





































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import {
  DxForm,
  DxItem,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue';

import SaveBar from '@/modules/shared/savebar/SaveBar.vue';
import Card from '@/components/default/Card.vue';

import TaskProceduresRepository from '@/modules/tasks/procedures/TaskProceduresRepository';
import TaskInstructionsRepository from '@/modules/tasks/shared/TaskInstructionsRepository';
import TaskTemplatesRepository from '../../templates/TaskTemplatesRepository';

import _ from 'lodash';

import { DxTreeList, DxEditing, DxColumn, DxRowDragging } from 'devextreme-vue/tree-list';

Component.registerHooks([
    'beforeRouteLeave',
]);

@Component({
  components: {
    DxForm,
    DxItem,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
    SaveBar,
    Card,
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxTreeList,
    DxColumn,
    DxEditing,
    DxRowDragging,
  },
})
export default class TaskProcedureDetailsPage extends Vue {
    private dto: ITaskProcedureUpdateCommand = {
        name: '',
        instructionId: '',
        id: '',
        items: [],
    };
    private addTemplateModel: any = {
        templateId: '',
    };
    private instructions: any[] = [];
    private templates: ITaskTemplateDto[] = [];
    private loading: boolean = false;
    private saving: boolean = false;
    private initialised: boolean = false;
    private dirty: boolean = false;
    private showPopup: boolean = false;

    private async save() {
        try {
            this.saving = true;
            const form: any = this.$refs.form;
            const validationResult = form.instance.validate();

            if (validationResult.isValid) {
                await TaskProceduresRepository.update(this.dto as ITaskProcedureUpdateCommand);
                notificationService.saved();
                this.dirty = false;
            } else {
                notificationService.invalidForm();
            }
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    private async loadInstructions() {
        try {
            this.instructions = (await TaskInstructionsRepository.getAll()).data;
        } catch {
            notificationService.showErrorMessage('Mislukt om de handleidingen te laden!');
        }
    }

    private async loadTemplates() {
        try {
            this.templates = (await TaskTemplatesRepository.getAll()).data;
        } catch {
            notificationService.showErrorMessage('Mislukt om de handleidingen te laden!');
        }
    }

    private async loadData() {
        try {
            this.loading = true;
            const res = (await TaskProceduresRepository.getSingle(this.id)).data;
            Object.assign(this.dto, res);
            setTimeout(() => {
                this.initialised = true;
            }, 300);
        } catch (error) {
            notificationService.showErrorMessage('Er is iets misgelopen tijdens het laden van de template!');
        } finally {
            this.loading = false;
        }
    }

    private onDragChange(e: any) {
        const visibleRows = e.component.getVisibleRows();
        const sourceNode = e.component.getNodeByKey(e.itemData.id);
        let targetNode = visibleRows[e.toIndex].node;

        while (targetNode && targetNode.data) {
            if (targetNode.data.id === sourceNode.data.id) {
                e.cancel = true;
                break;
            }

            targetNode = targetNode.parent;
        }
    }

    private onReorder(e: any) {
        const visibleRows = e.component.getVisibleRows();
        const sourceData = e.itemData;
        const targetData = visibleRows[e.toIndex].data;

        if (e.dropInsideItem) {
            e.itemData.parentId = targetData.id;
            e.component.refresh();
        } else {
            const sourceIndex = this.dto.items.indexOf(sourceData);
            let targetIndex = this.dto.items.indexOf(targetData);

            if (sourceData.parentId !== targetData.parentId) {
                sourceData.parentId = targetData.parentId;
                if (e.toIndex > e.fromIndex) {
                    targetIndex++;
                }
            }

            this.dto.items.splice(sourceIndex, 1);
            this.dto.items.splice(targetIndex, 0, sourceData);
        }
    }

    private created() {
        if (this.id) {
            this.loadData();
        } else {
            this.initialised = true;
        }
        this.loadTemplates();
        this.loadInstructions();
    }

    private beforeRouteLeave(to: any, from: any, next: any) {
        if (this.dirty) {
            if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    }

    private addTemplate() {
        const form: any = this.$refs.addTemplateForm;
        const validationResult = form.instance.validate();

        if (!validationResult.isValid) {
            notificationService.invalidForm();
            return;
        }

        let guid = _.uniqueId('item');

        while ( this.dto.items.findIndex((o) => o.id === guid) !== -1) {
            guid = _.uniqueId('item');
        }

        this.dto.items.push({
            id: guid,
            templateId: this.addTemplateModel.templateId,
            parentId: null,
        });

        this.addTemplateModel.templateId = '';

        this.showPopup = false;
    }

    get title() {
        return this.id ? 'Taak procedure wijzigen' : 'Taak procedure aanmaken';
    }

    get id() {
        return this.$route.params.id;
    }

    get instructionsOptions() {
        return {
            items: this.instructions,
            displayExpr: 'name',
            valueExpr: 'key',
            searchEnabled: true,
            showClearButton: true,
        };
    }

    get templatesOptions() {
        return {
            items: this.templates,
            displayExpr: 'name',
            valueExpr: 'id',
            searchEnabled: true,
            showClearButton: true,
        };
    }

    @Watch('dto', { deep: true })
    private onDtoChanged() {
        if (this.initialised) {
            this.dirty = true;
        }
    }
}
